module.exports = __webpack_public_path__ + "img/Group 4.77bf7449.png";